import { render } from "./OtherProduct.vue?vue&type=template&id=54eeb075&scoped=true"
import script from "./OtherProduct.vue?vue&type=script&lang=js"
export * from "./OtherProduct.vue?vue&type=script&lang=js"

import "./OtherProduct.vue?vue&type=style&index=0&id=54eeb075&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54eeb075"]])

export default __exports__